export type ValueOf<T> = T[keyof T]

export const PaymentFrequency = Object.freeze({
  Annually: 1,
  Quarterly: 4,
  Bimonthly: 6,
  Monthly: 12,
  Fortnightly: 26,
  Weekly: 52,
} as const)

export type PaymentFrequencies = keyof typeof PaymentFrequency
export type PaymentFrequencyValues = ValueOf<typeof PaymentFrequency>

export type OptionalNumber = number | ''

export type SelectOptions<T, D = unknown> = {
  label: string
  value: T
  default?: boolean
  data?: D
}[]

export interface InputProps<T> {
  value: T
  onChange: (value: T) => void
}

export interface InputPropsWithOptions<T> extends InputProps<T> {
  options: SelectOptions<T>
}
